<template>
  <ModalRoot class="gallery-modal" :isDynamic="true" @load="loadHotelPhotos" @close="$emit('close')">
    <div class="gallery-modal__header" slot="header">
      <div>
        <div class="gallery-modal__location">
          <span class="span_underline">
            <span class="gallery-modal__location-name">{{ offer.Hotel_Location_Name }}</span>
            /
            <span class="gallery-modal__location-city">{{ offer.Merlin_City }}</span>
          </span>
        </div>
        <div class="gallery-modal__hotel">
          <span class="gallery-modal__hotel-name">{{ offer.Hotel_Name }}</span>
          <span :class="[ 'stars', 'stars--white', offer.Hotel_Standard_Stars_Css, 'offer-list-item__hotel-standard' ]" />
        </div>        
      </div>
      <button @click="$emit('close')" class="gallery-modal__close figure figure--cross" />
    </div>
    <template slot-scope="{ data }">
      <div v-if="mode == 'slideshow'">
        <Swiper ref="fullSwiper" mode="full" class="gallery-modal__full"
          :images="data.images.full"
          :initialSlide="pictureIndex"
          @selected="fullImageSelected" />
        
        <div class="gallery-modal__thumbnails">
          <Swiper ref="previewSwiper" class="gallery-modal__thumbnails--slider" mode="preview"
            :images="data.images.thumbnail"
            :initialSlide="pictureIndex"
            @selected="previewImageSelected" />
          <button class="gallery-modal__show-all" @click="showAllPictures">
            Zobacz wszystkie zdjęcia
            <Icon icon="arr-right" />
          </button>
        </div>
      </div>
      <ImageGrid v-if="mode == 'preview'"
        :images="data.images.preview"
        @selected="showSlideshow" />
    </template>
  </ModalRoot>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import ImageGrid from './ImageGrid'
import Swiper from './Swiper'

import Icon from '@/components/Icon'
import Loader from '@/components/Loader.vue'
import ModalRoot from '@/components/ModalRoot'
import { API } from '@/modules/api'

@Component({
  components: {
    ModalRoot,
    Loader,
    Swiper,
    ImageGrid,
    Icon,
  },
  props: {
    offer: {
      required: true,
      type: Object, // Offer returned from API.getOffersList
    },
  },
})
export default class GalleryModal extends Vue {
  mode = 'slideshow' // Or 'preview' to see a preview of all pictures
  pictureIndex = 0

  loadHotelPhotos (done) {
    new API().getHotelPictures(this.offer.Hotel_Id).then(done)
  }

  showAllPictures () {
    this.mode = 'preview'
  }

  showSlideshow (fromIndex) {
    this.mode = 'slideshow'
    this.pictureIndex = fromIndex
  }

  fullImageSelected ({ index }) {
    this.$refs.previewSwiper.swiper.slideToLoop(index, 0)
  }

  previewImageSelected ({ index }) {
    this.$refs.fullSwiper.swiper.slideToLoop(index, 0)
  }
}
</script>

<style lang="scss">
.gallery-modal {
  text-transform: uppercase;
  color: white;

  &__header {
    width: 100%;
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
  }

  &__location {
    font-size: 12px;
    color: white;

    .span_underline {
      color: white;

      &:after {
        background: white;
      }
    }
  }

  &__location-name {
    font-weight: 700;
  }

  &__location-city {
    font-weight: 500;
  }

  &__hotel {
  }

  &__hotel-name {
    font-size: 22px;
  }

  &__close {
    margin-left: auto;
    border: 0;
    background: transparent;
    margin-right: -8px;
  }

  &__thumbnails {
    display: none;
    align-items: center;
    margin-top: 15px;

    @include media(tablet) {
      display: flex;
    }

    &--slider {
      max-width: 435px;
      margin-left: 0 !important;
    }

    img {
      cursor: pointer;
    }
  }

  &__show-all {
    display: flex;
    align-items: center;
    background: transparent;
    border: 2px solid #fff;
    height: 40px;
    padding: 0 10px;

    .figure {
      font-size: 12px;
      margin-left: 10px;
      margin-top: -2px;
    }
  }

  &__full {
    position: relative;
    
    .swiper-button-prev,
    .swiper-button-next {
      background-image: none;
    }
  }

  .stars {
    vertical-align: initial;
    margin-left: 5px;
  }

  .modal-dialog__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offers-list/GalleryModal.vue